module.exports = __webpack_public_path__ + "img/Handleidingen.ddd5d8ea.svg";